import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd'; // Usamos Modal de Ant Design
import { Link } from 'react-router-dom';
import { auth, functions } from '../../firebase'; // Si usas Firebase para la autenticación
import { httpsCallable } from 'firebase/functions';
import { useNavigate } from 'react-router-dom';
import firebase from 'firebase/app'; // Asegúrate de que Firebase esté configurado
import { useUser } from '../../providers/UserContext';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getAuth, signOut } from 'firebase/auth';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

import './Profile.css';

const Profile = ({ selected }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { user } = useUser();
  const [businessData, setBusinessData] = useState(user?.business_data || null);
  const [usuario, setUser] = useState(null);
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [telefono, setTelefono] = useState('');
  const [mailContacto, setMailContacto] = useState('');
  const [direccion, setDireccion] = useState('');
  const [fechaExpiracion, setFechaExpiracion] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [progressBar, setProgressBar] = useState(0);
  const [missingFields, setMissingFields] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [error, setError] = useState(false);
  const [mapUrl, setMapUrl] = useState('');


  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      validateForm();
      if (user && isFormValid) {
        user.nombre_usuario = nombreUsuario.trim();
        user.mail_contacto = mailContacto.trim();
        user.telefono = telefono.trim() || null;
        user.direccion = direccion.trim() || null;
        await axios.post(`${apiUrl}/collections/update-user`, {
          email: user.email,
          id_negocio: user.id_negocio,
          nombre_usuario: nombreUsuario.trim(),
          telefono: telefono.trim() || null,
          mail_contacto: mailContacto.trim(),
          direccion: direccion.trim() || null,
        });
        setShowConfirmation(true);
        setTimeout(() => setShowConfirmation(false), 5000);
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error al guardar la información:', error);
    }
  };

  const validateForm = () => {
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phonePattern = /^[0-9]{9}$/;
    const errors = {};

    // Validación de cada campo
    if (!nombreUsuario.trim()) {
      errors.nombreUsuario = t("principalFormUsernameRequired");
    }
    if (!mailContacto.trim()) {
      errors.mailContacto = t("principalFormEmailRequired");
    } else if (!emailPattern.test(mailContacto)) {
      errors.mailContacto = t("principalFormEmailInvalid");
    }
    if (telefono && !phonePattern.test(telefono)) {
      errors.telefono = t("principalFormPhoneInvalid");
    }

    setFormErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0); // Formulario válido si no hay errores
  };

  useEffect(() => {
    validateForm()
  }, [nombreUsuario, direccion, mailContacto, telefono]);

  useEffect(() => {

    const fetchData = async () => {
      if (user && user.businessId) {
        try {
          if (businessData) {
            // const collection = 'todo_restaurantes_españa';
            // const response = await axios.get(`${apiUrl}/collections/${collection}/${user.businessId}`);
            if (businessData.horario) {
              const sortedDays = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábado", "domingo"]
              businessData.horario.sort((a, b) => sortedDays.indexOf(a[0]) - sortedDays.indexOf(b[0]));
              businessData.horario = businessData.horario.map(([day, schedule]) => [t(day), schedule === "Cerrado" ? t("closed") : schedule]);
            }

            // setBusinessData(response.data);
            checkProgressBar(businessData);
            setMap(businessData);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          setError(true);
        }

        try {
          // var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
          // const response = await axios.get(`${apiUrl}/collections/user/${userUID}`);
          // setUser(response.data);
          setNombreUsuario(user.nombre_usuario || user.displayName || '');
          setDireccion(user.direccion || '');
          setTelefono(user.telefono || '');
          setMailContacto(user.mail_contacto || user.email || '');
          if(user.is_premium)
            setFechaExpiracion(sumarUnMes(user.date));
          else
            setFechaExpiracion(sumarSieteDias(user.date));

          setLoading(false);
        } catch (error) {
          console.error('Error fetching data:', error);
          setError(true);
        }
      }
    };

    const sumarUnMes = (fechaUsuario) => {
      const [dia, mes, anio] = fechaUsuario.split('/').map(Number);
      const fecha = new Date(anio, mes - 1, dia);
      fecha.setMonth(fecha.getMonth() + 1);
      const nuevoDia = ('0' + fecha.getDate()).slice(-2);
      const nuevoMes = ('0' + (fecha.getMonth() + 1)).slice(-2);
      return `${nuevoDia}/${nuevoMes}/${fecha.getFullYear()}`;
    }

    const sumarSieteDias = (fechaUsuario) => {
      const [dia, mes, anio] = fechaUsuario.split('/').map(Number);
      const fecha = new Date(anio, mes - 1, dia); // Crear un objeto Date
      fecha.setDate(fecha.getDate() + 7); // Sumar 7 días
    
      // Formatear el nuevo día y mes
      const nuevoDia = ('0' + fecha.getDate()).slice(-2);
      const nuevoMes = ('0' + (fecha.getMonth() + 1)).slice(-2);
      return `${nuevoDia}/${nuevoMes}/${fecha.getFullYear()}`; // Retornar la nueva fecha en formato DD/MM/YYYY
    };

    if (businessData) {
      setLoading(false);
      if (selected) {
        fetchData();
      }
    } else {
      setLoading(true)
      setBusinessData(user?.business_data || null)
    }
  }, [businessData, user, selected, i18n.language]);

  const checkProgressBar = (businessData) => {
    const totalFields = 8;
    let progress = 0;
    let missingFields = [];

    if (businessData) {
      // Verificamos cada campo y añadimos los que faltan al array 'missingFields'
      if (businessData.nombre) progress += 1; else missingFields.push('Nombre');
      if (businessData.telefono) progress += 1; else missingFields.push('Teléfono');
      if (businessData.categorias) progress += 1; else missingFields.push('Categorías');
      if (businessData.localidad) progress += 1; else missingFields.push('Localidad');
      if (businessData.codigopostal) progress += 1; else missingFields.push('Código Postal');
      if (businessData.url) progress += 1; else missingFields.push('Web');
      if (businessData.email) progress += 1; else missingFields.push('Email');
      if (businessData.horario) progress += 1; else missingFields.push('Horario');
      // if (businessData.horaspunta) progress += 1; else missingFields.push('Horas Punta');
    }

    setProgressBar((progress / totalFields) * 100);
    setMissingFields(missingFields);
  };

  const setMap = (businessData) => {
    let newUrl;
    if (businessData) {
      try {
        const businessName = encodeURIComponent(businessData.nombre);
        const businessAddress = encodeURIComponent(businessData.id_tipo_nombre_direccion);
        newUrl = businessData.iframeUrl.replace(businessName, `${businessName}+${businessAddress}`);
      } catch (error) {
        console.error('Error al reemplazar en iframeUrl:', error);
        newUrl = businessData.iframeUrl;
      }
      const finalUrl = newUrl.replace(/1ses!2ses/g, `1s${i18n.language}!2s${i18n.language}`);
      setMapUrl(finalUrl);
    }
  }

  useEffect(() => {
    if (error) {
      navigate('/404'); // Redirige a la página 404 si hay un error
    }
  }, [error, navigate]);

  const renderInfoItem = (label, value, nullMessage, isSchedule = false) => (
    <div className="mb-2">
      <label className="form-label profile-label">{label}</label>
      {isSchedule ? (
        <div className="dropdown">
          <button className="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownSchedule" data-bs-toggle="dropdown" aria-expanded="false">
            {t('viewSchedule')}
          </button>
          <div className="dropdown-menu p-3" aria-labelledby="dropdownSchedule" style={{ minWidth: '250px' }}>
            {value ? (
              <ul className="list-unstyled m-0">
                {value.map((dia, index) => (
                  <li key={index} className="small">
                    <strong>{dia[0]}:</strong> {dia[1]}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-danger small m-0">{nullMessage}</p>
            )}
          </div>
        </div>
      ) : (
        <p className="mb-0">{value || <span className="text-danger">{nullMessage}</span>}</p>
      )}
    </div>
  );

  const handleCancelSubscriptionClick = () => {
    setShowCancelConfirmation(true);
  };

  const handleConfirmCancelSubscription = async () => {
    try {
      const response = await axios.post(`${apiUrl}/collections/cancel-subscription`, {
        email: user.email,
        id_negocio: user.id_negocio,
        is_premium: false,
        stripeId: usuario.stripeId
      });

      if (response.status === 200) {
        setShowCancelConfirmation(false);
        setShowSuccessModal(true);
        sendAccountCancelationEmail(user.email, user.displayName)
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        console.error('Error al anular la suscripción:', response);
      }
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
    }

    setShowCancelConfirmation(false);
  };

  const sendAccountCancelationEmail = async (email, displayName) => {
    try {
      console.log("MANDANDO MAIL DE CANCELACIÓN DE SUSCRIPCIÓN");
      const sendWelcomeEmail = httpsCallable(functions, 'sendWelcomeEmail');

      const logoUrl = 'https://reveat.pro/assets/images/RevEat_Logo_PNG.png';
      const reveatYellow = getComputedStyle(document.documentElement).getPropertyValue('--reveat-yellow').trim();

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Confirmación de Pago</title>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
           <style type="text/css">
                  @media screen {
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 400;
                          src: local('Lato Regular'), local('Lato-Regular'), url(https://fonts.gstatic.com/s/lato/v11/qIIYRU-oROkIk8vfvxw6QvesZW2xOQ-xsNqO47m55DA.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: normal;
                          font-weight: 700;
                          src: local('Lato Bold'), local('Lato-Bold'), url(https://fonts.gstatic.com/s/lato/v11/qdgUG4U09HnJwhYI-uK18wLUuEpTyoUstqEm5AMlJo4.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 400;
                          src: local('Lato Italic'), local('Lato-Italic'), url(https://fonts.gstatic.com/s/lato/v11/RYyZNoeFgb0l7W3Vu1aSWOvvDin1pK8aKteLpeZ5c0A.woff) format('woff');
                      }
                      @font-face {
                          font-family: 'Lato';
                          font-style: italic;
                          font-weight: 700;
                          src: local('Lato Bold Italic'), local('Lato-BoldItalic'), url(https://fonts.gstatic.com/s/lato/v11/HkF_qI1x_noxlxhrhMQYELO3LdcAZYWl9Si6vvxL-qU.woff) format('woff');
                      }
                  }
                  body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
                  table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
                  img { -ms-interpolation-mode: bicubic; }
                  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
                  table { border-collapse: collapse !important; }
                  body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
                  a[x-apple-data-detectors] { color: inherit !important; text-decoration: none !important; font-size: inherit !important; font-family: inherit !important; font-weight: inherit !important; line-height: inherit !important; }
                  @media screen and (max-width:600px) { h1 { font-size: 32px !important; line-height: 32px !important; } }
                  div[style*="margin: 16px 0;"] { margin: 0 !important; }
              </style>
        </head>
        <body style="background-color: #f4f4f4; margin: 0 !important; padding: 0 !important;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%">
          <tr>
            <td bgcolor="${reveatYellow}" align="center">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                <tr>
                  <td align="center" valign="top" style="padding: 40px 10px 40px 10px;">
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td bgcolor="${reveatYellow}" align="center" style="padding: 0px 10px 0px 10px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                <tr>
                  <td bgcolor="#ffffff" align="center" valign="top" style="padding: 40px 20px 20px 20px; border-radius: 4px 4px 0px 0px; color: #111111; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 48px; font-weight: 400; line-height: 48px;">
                    <h1 style="font-size: 48px; font-weight: 400; margin: 2;">Hola ${displayName},</h1>
                    <img src="${logoUrl}" width="160" height="120" style="display: block; border: 0px; margin: 30px 20px 20px 20px" />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td bgcolor="#f4f4f4" align="center" style="padding: 0px 10px 0px 10px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                <tr>
                  <td bgcolor="#ffffff" align="left" style="padding: 20px 30px 40px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px; text-align:center">
                    <p style="margin: 0;">
                      Lamentamos informarte que tu <b>Suscripción</b> en <b>RevEat</b> ha sido cancelada. A partir de ahora, ya no tendrás acceso a las funcionalidades exclusivas. Volverás a disfrutar de un periodo gratis de 7 días.
                    </p>
                    <br>
                    <p style="margin: 0;">
                      Si en algún momento deseas volver a disfrutar de todas las ventajas que ofrece nuestro plan Premium, siempre puedes actualizar tu cuenta nuevamente.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#ffffff" align="center" style="padding: 20px 30px 60px 30px;">
                    <a href="${window.location.origin}/plans" target="_blank" style="font-size: 20px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; padding: 15px 25px; border-radius: 20px; background-color: ${reveatYellow}; border: 1px solid ${reveatYellow};">Actualizar a Premium</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td bgcolor="#f4f4f4" align="center" style="padding: 30px 10px 0px 10px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                <tr>
                  <td bgcolor="#FFFFFF" align="center" style="padding: 30px 30px 30px 30px; border-radius: 4px 4px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                    <h2 style="font-size: 20px; font-weight: 400; color: #111111; margin: 0;">¿Tienes alguna duda?</h2>
                    <p style="margin: 0;">
                      <a href="${window.location.origin}/faq" target="_blank" style="color: ${reveatYellow};">Estamos aquí para ayudarte</a>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </body>
        </html>
      `;

      const result = await sendWelcomeEmail({
        to: email,
        subject: `¡Suscripción cancelada, ${displayName}!`,
        text: `Hola ${displayName}, tu suscripción a Reveat ha sido anulada.`,
        html: htmlContent
      });

      console.log('Email de cancelación enviado:', result.data);
    } catch (error) {
      console.error('Error al enviar el email de cancelación de suscripción:', error);
    }
  };

  function handleConfirmLogout() {
    setShowLogoutConfirmation(false); // Cerrar el modal primero

    const auth = getAuth();

    signOut(auth)
      .then(() => {
        // Limpia la caché
        localStorage.clear();
        sessionStorage.clear();

        // Navegar a la página de inicio de sesión
        navigate('/login');
      })
      .catch((error) => {
        console.error("Error al cerrar sesión: ", error);
      });
  }


  const handleCancelModal = () => {
    setShowCancelConfirmation(false);
  };
 
  if (loading) {
    return <LoadingScreen setLoadingComplete={setLoadingComplete} />;
  }

  return (
    <div className="content pt-0 profile">
      <div className='footer-margin'>
      {/* Business Information */}
      <div className="card">
        <div className="card-header custom-header">
          <div className="header-content">
            <h5 className="mb-0">{t('businessInfo')}</h5>
            <div className="progress-wrapper">
              <div
                className="progress-bar-container"
                title={
                  missingFields.length > 0
                    ? t('profileTooltipMissingFields') + `${missingFields.join(', ')}`
                    : t('profileTooltipCompleted')
                }
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
              >
                <div
                  className="progress-bar bg-success"
                  role="progressbar"
                  style={{ width: `${progressBar}%` }}
                  aria-valuenow={progressBar}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <small className="text-muted">{Math.round(progressBar)}%</small>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row g-3">
            {businessData && Object.keys(businessData).length > 0 && (
              <>
                <div className="col-md-4">
                  <h6 className="border-bottom pb-2 mb-3">{t('mainInfo')}</h6>
                  {renderInfoItem(t('name'), businessData.nombre, t('nameNull'))}
                  {renderInfoItem(t('business'), businessData.categorias?.join(', '), t('businessNull'))}
                  {renderInfoItem(t('url'), businessData.url, t('urlNull'))}
                  {Array.isArray(businessData.email) ? (
                    renderInfoItem(t('email'), businessData.email[0], t('emailNull'))
                  ) : (
                    renderInfoItem(t('email'), businessData.email, t('emailNull'))
                  )}

                  {renderInfoItem(t('phone'), businessData.telefono, t('phoneNull'))}
                </div>
                <div className="col-md-4">
                  <h6 className="border-bottom pb-2 mb-3">{t('location')}</h6>
                  {renderInfoItem(t('address'), businessData.direccion?.[0], t('addressNull'))}
                  {renderInfoItem(t('city'), businessData.localidad, t('cityNull'))}
                  {renderInfoItem(t('province'), businessData.direccion?.[2], t('provinceNull'))}
                  {renderInfoItem(t('zip'), businessData.codigopostal, t('zipNull'))}
                  {renderInfoItem(t('schedules'), businessData.horario, t('scheduleNull'), true)}
                </div>
              </>
            )}
            <div className="col-md-4" style={{ marginTop: 70 }}>
              <div className="ratio ratio-4x3">
                <iframe
                  src={mapUrl}
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen
                  title="Business Location"
                ></iframe>
              </div>
              {/* <h6 className="border-bottom pb-2 mb-3">{t('peakHours')}</h6>
            {businessData.horaspunta ? (
              <ul className="list-unstyled">
                {businessData.horaspunta.map((hour, index) => (
                  <li key={index} className="small">
                    {hour[4]} - {hour[2]}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-danger small">{t('peakHoursNull')}</p>
            )} */}
            </div>
          </div>
        </div>
      </div>

      {/* Profile Information */}
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">{t('userInfo')}</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label profile-label">{t('username')}</label>
                  <input type="text" id="nombreUsuario" value={nombreUsuario} className="form-control" onChange={(e) => setNombreUsuario(e.target.value)} placeholder={t('usernamePlaceholder')}/>
                  {formErrors.nombreUsuario && (
                  <div className="text-danger">{formErrors.nombreUsuario}</div>)}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label profile-label">{t('address')}</label>
                  <input type="text" id="direccion" value={direccion} onChange={(e) => setDireccion(e.target.value)} className="form-control" placeholder={t('addressPlaceholder')} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label profile-label">{t('email')}</label>
                  <input type="text" id="mailContacto" value={mailContacto} onChange={(e) => setMailContacto(e.target.value)} className="form-control" placeholder={t('emailPlaceholder')}/>
                  {formErrors.mailContacto && (
                  <div className="text-danger">{formErrors.mailContacto}</div>)}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label profile-label">{t('phone')}</label>
                  <input type="text" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)} className="form-control" placeholder={t('phonePlaceholder')} />
                  {formErrors.telefono && (
                  <div className="text-danger">{formErrors.telefono}</div>)}
                </div>
              </div>
            </div>

            <div className="text-end">
              <div className="row">
                <div className="col-lg-10">
                  {showConfirmation && <p className="text-success mt-1">{t('editUserSuccesfully')}</p>}
                </div>
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-basic" disabled={!isFormValid}>{t('saveButton')}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Account Settings */}
      <div className="card account">
        <div className="card-header">
          <h5 className="mb-0">{t('accountSettings')}</h5>
        </div>

        <div className="card-body">
          <form action="#">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label profile-label">{t('activePlan')}</label>
                  {user && user.is_premium ? (
                    <p className="form-control-p">{t('premiumPlan')}</p>
                  ) : (
                    <p className="form-control-p">{t('basicPlan')}</p>
                  )}
                </div>
              </div>

              <div className="col-lg-6">
                  {user && user.is_premium?(
                    <div className="mb-3">
                      <label className="form-label profile-label">{t('subscriptionCost')}</label>
                      <p className="form-control-p">{t('premiumPrice')}</p>
                    </div>
                  ):(
                    <div className="mb-3">
                      <label className="form-label profile-label">{t('subscriptionDate')}</label>
                      <p className="form-control-p">{user && user.date}</p>
                    </div>
                  )}
              </div>
            </div>

              {user && user.is_premium?(
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className="mb-3">
                      <label className="form-label profile-label">{t('subscriptionDate')}</label>
                      <p className="form-control-p">{user.date}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label profile-label">{t('expirationDate')}</label>
                      <p className="form-control-p">{fechaExpiracion}</p>
                      <p className="form-control-p-custom">{t('automaticRenew')}</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <button className="btn btn-basic me-2"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowLogoutConfirmation(true); // Mostrar el modal de confirmación de cierre de sesión
                      }}
                      >
                        {t('logout')}
                    </button>
                    <button className="btn btn-basic" 
                            onClick={(e)=>{
                              e.preventDefault(); 
                              handleCancelSubscriptionClick()}
                            }>
                      {t('cancelPlan')}
                    </button>
                  </div>
                </div>
              ):(
                <div className='row'>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label profile-label">{t('expirationDate')}</label>
                      <p className="form-control-p">{fechaExpiracion}</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <button className="btn btn-basic me-2"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowLogoutConfirmation(true); // Mostrar el modal de confirmación de cierre de sesión
                            }}
                            >
                            {t('logout')}
                    </button>
                    <Link to="/plans" className="btn btn-basic btnPremium">{t('upgradePlan')}</Link>
                  </div>
                </div>
              )
              }

            {/* Modal de confirmación de cierre de sesión */}
            <Modal
              visible={showLogoutConfirmation}
              onCancel={() => setShowLogoutConfirmation(false)}
              footer={null}
              title={t('confirmLogoutTitle')}
            >
              <p>{t('confirmLogoutBody')}</p>
              <div className='profile-modal'>
                <Button type="danger" className='custom-btn danger-button' onClick={handleConfirmLogout}>
                  {t('confirmLogoutButton')}
                </Button>
              </div>
            </Modal>

            {/* Modal de confirmación de cancelación del plan */}
            <Modal
              visible={showCancelConfirmation}
              onCancel={handleCancelModal}
              footer={null}
              title={t('confirmCancelationTitle')}
            >
              <p>{t('confirmCancelationBody')}</p>
              <div className='profile-modal'>
                <Button type="danger" className='custom-btn danger-button' onClick={handleConfirmCancelSubscription}>
                  {t('confirmCancelationButton')}
                </Button>
              </div>
            </Modal>

            {/* Modal de éxito al confirmar la cancelación */}
            <Modal
              visible={showSuccessModal}
              onCancel={handleCancelModal}
              footer={null}
            >
              <h3>{t('cancelPlanSuccessTitle')}</h3>
              <p>{t('cancelPlanSuccessBody')}</p>
            </Modal>
          </form>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Profile;
